<main>
  <router-outlet></router-outlet>
  <app-toast></app-toast>
</main>
